import React from "react";
import T from "prop-types";
import { Field, FormSection } from "redux-form";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import * as actions from "MODULES/SalesOrders/actions";
import {
  form,
  Form as AppForm,
  CurrencyField,
  CheckGroup,
  Check,
  FormRow,
  FormInput,
  TextArea
} from "MODULES/shared/components/Forms";
import { properCase } from "LIB/formatters/text";
import {
  EXCHANGE_SPECIAL_INSTRUCTIONS,
  FLAT_EXCHANGE,
  OUTRIGHT_VALUE,
  REPAIR_FEE
} from "MODULES/SalesOrders/constants";
import { BlanketExchangeAgreementWarning } from "MODULES/SalesOrders/components/ConvertFromCartForm/Warnings";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import ShippingFields from "MODULES/Orders/shared/ShippingFields/ShippingFields";
import {
  RETURN_TO,
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_LOCATION_ID,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_TYPE
} from "APP_ROOT/constants";
import {
  CORE_DUE_DAYS,
  CORE_RETURN_DATE
} from "MODULES/RepairOrders/constants";
import { addDays } from "LIB/time";
import { CORE_DUE_DATE } from "MODULES/PurchaseOrders/constants";
import { validate } from "./validate";

const FORM_NAME = "convertToExchange";

function Form(props) {
  const flatExchange = props.getFieldValue(FLAT_EXCHANGE);

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={3}>
            <CheckGroup title={properCase(FLAT_EXCHANGE)} justified>
              <Field
                name={FLAT_EXCHANGE}
                component={Check}
                label={properCase(FLAT_EXCHANGE)}
              />
            </CheckGroup>
          </Col>
          <Col md={3}>
            <CurrencyField
              required
              name={EXCHANGE_FEE}
              label={flatExchange ? "Flat Exchange Fee" : "Exchange Fee"}
            />
          </Col>
          <Col md={3}>
            <CurrencyField
              required
              name={OUTRIGHT_VALUE}
              label={properCase(OUTRIGHT_VALUE)}
            />
          </Col>
        </FormRow>
        <FormRow>
          <BlanketExchangeAgreementWarning
            company={props.salesOrder.company}
            exchangeSale
          />
        </FormRow>

        <FormRow>
          <Col md={4}>
            <Field
              name={CORE_DUE_DAYS}
              component={FormInput}
              label={properCase(CORE_DUE_DAYS)}
              onChange={(_evt, val) => {
                if (val) {
                  const days = addDays(new Date(), Number(val));
                  props.setFieldValue(CORE_RETURN_DATE)(
                    new Date(days).toISOString().split("T")[0]
                  );
                }
              }}
              required
            />
          </Col>
          <Col md={4}>
            <Field
              label={properCase(CORE_DUE_DATE)}
              name={CORE_RETURN_DATE}
              component={FormInput}
              type="date"
              required
            />
          </Col>
          <Col md={3}>
            <CurrencyField
              name={REPAIR_FEE}
              label="Avg Repair (NTX)"
              required={flatExchange}
            />
          </Col>
        </FormRow>
        <FormRow className="row-col-gutters-half">
          <Col md={12}>
            <Field
              name={EXCHANGE_SPECIAL_INSTRUCTIONS}
              component={TextArea}
              label="Special Instructions (to be incl. on Exch Agreement)"
              maxLength={150}
              rows="5"
              cols="50"
            />
          </Col>
        </FormRow>
        <FormSection name="">
          <h4>Return To</h4>
          <ShippingFields
            shipToCompany={props.salesOrder.return_to_company}
            key="return-to-shipping-fields"
            formName={FORM_NAME}
            path={RETURN_TO}
            renderCarrier={false}
            shippingFields={[
              RETURN_TO_TYPE,
              RETURN_TO_COMPANY_ID,
              RETURN_TO_COMPANY_ADDRESS_ID
            ]}
            shippingTypes={[]}
            shippingAddressField={RETURN_TO_SHIPPING_ADDRESS}
            locationFieldName={RETURN_TO_LOCATION_ID}
            required
          />
          <Field
            name="return_to_fob"
            component={FormInput}
            label="Return To FOB"
            required
          />
        </FormSection>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  lineItem: T.shape({
    received: T.bool.required
  })
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(actions.convertToExchange(ownProps.lineItem.id, data))
}))(
  form({
    form: FORM_NAME,
    validate
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/ConvertToExchange/Form.jsx